/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Discount } from './Discount';
import {
    DiscountFromJSON,
    DiscountFromJSONTyped,
    DiscountToJSON,
} from './Discount';
import type { Money } from './Money';
import {
    MoneyFromJSON,
    MoneyFromJSONTyped,
    MoneyToJSON,
} from './Money';
import type { QuantityPrice } from './QuantityPrice';
import {
    QuantityPriceFromJSON,
    QuantityPriceFromJSONTyped,
    QuantityPriceToJSON,
} from './QuantityPrice';

/**
 * 
 * @export
 * @interface Price
 */
export interface Price {
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    id?: string;
    /**
     * 
     * @type {Money}
     * @memberof Price
     */
    listPrice?: Money;
    /**
     * 
     * @type {Money}
     * @memberof Price
     */
    salesPrice?: Money;
    /**
     * 
     * @type {Money}
     * @memberof Price
     */
    vatAmount?: Money;
    /**
     * 
     * @type {number}
     * @memberof Price
     */
    vatRate?: number;
    /**
     * 
     * @type {Array<Discount>}
     * @memberof Price
     */
    discounts?: Array<Discount>;
    /**
     * 
     * @type {{ [key: string]: QuantityPrice | undefined; }}
     * @memberof Price
     */
    quantityPrices?: { [key: string]: QuantityPrice | undefined; };
}

/**
 * Check if a given object implements the Price interface.
 */
export function instanceOfPrice(value: object): boolean {
    return true;
}

export function PriceFromJSON(json: any): Price {
    return PriceFromJSONTyped(json, false);
}

export function PriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Price {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'listPrice': json['listPrice'] == null ? undefined : MoneyFromJSON(json['listPrice']),
        'salesPrice': json['salesPrice'] == null ? undefined : MoneyFromJSON(json['salesPrice']),
        'vatAmount': json['vatAmount'] == null ? undefined : MoneyFromJSON(json['vatAmount']),
        'vatRate': json['vatRate'] == null ? undefined : json['vatRate'],
        'discounts': json['discounts'] == null ? undefined : ((json['discounts'] as Array<any>).map(DiscountFromJSON)),
        'quantityPrices': json['quantityPrices'] == null ? undefined : (mapValues(json['quantityPrices'], QuantityPriceFromJSON)),
    };
}

export function PriceToJSON(value?: Price | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'listPrice': MoneyToJSON(value['listPrice']),
        'salesPrice': MoneyToJSON(value['salesPrice']),
        'vatAmount': MoneyToJSON(value['vatAmount']),
        'vatRate': value['vatRate'],
        'discounts': value['discounts'] == null ? undefined : ((value['discounts'] as Array<any>).map(DiscountToJSON)),
        'quantityPrices': value['quantityPrices'] == null ? undefined : (mapValues(value['quantityPrices'], QuantityPriceToJSON)),
    };
}

